import { Link } from "react-router-dom";
import {
  APPSTORE_URL,
  PLAYSTORE_URL,
  QUICK_LOAN_INTEREST_RATE,
} from "../../constants.js";

import { Button } from "../button/index.jsx";
import { Icon } from "../Icon/icon.js";

const sections = [
  {
    tile: <>PRODUCTS</>,
    links: [
      {
        title: "Savings",
        to: "/#savings",
        isLink: true,
        isHeader: true,
      },
      {
        title: "Autosave",
        to: "/#savings",
        isLink: true,
      },
      {
        title: "Vault",
        to: "/#savings",
        isLink: true,
      },
      {
        title: "Flexysave",
        to: "/#savings",
        isLink: true,
      },
      {
        title: "Loans",
        to: "/#loans",
        isLink: true,
        isHeader: true,
      },
      {
        title: "Personal Loans",
        to: "/#loans",
        isLink: true,
      },
      // {
      //   title: "Business Loans",
      //   to: "/#products",
      //   isLink: true,
      // },
      // {
      //   title: "Emergency Loans",
      //   to: "/#products",
      //   isLink: true,
      // },
      {
        title: "Buzz",
        to: "/#buzz",
        isLink: true,
        isHeader: true,
      },
      {
        title: "Chat & Pay",
        to: "/#buzz",
        isLink: true,
      },
      {
        title: "Find Friends",
        to: "/#buzz",
        isLink: true,
      },
      {
        title: "Earn Rewards",
        to: "/#buzz",
        isLink: true,
      },
    ],
  },
  {
    tile: <>FOLLOW</>,
    links: [
      {
        title: (
          <>
            <Icon svg="facebook" width={20} height={20} /> Facebook
          </>
        ),
        to: "https://web.facebook.com/share/v/192RjWTpw2/",
        isLink: true,
      },
      {
        title: (
          <>
            <Icon svg="twitter" width={20} height={20} /> X{" "}
            <span className="text-xs italic">(Twitter)</span>
          </>
        ),
        to: "https://x.com/mycardglobal?s=11&t=3AKJA_mS2dHatgAEhGpBUw",
        isLink: true,
      },
      {
        title: (
          <>
            <Icon svg="instagram" width={20} height={20} /> Instagram
          </>
        ),
        to: "https://www.instagram.com/p/DciUgk5OimC/?igsi=MXh4d24xaHoxOWtiag==",
        isLink: true,
      },
      {
        title: (
          <>
            <Icon svg="linkedIn" width={20} height={20} /> Linkedin
          </>
        ),
        to: "https://lnkd.in/p/e2FQRBs7",
        isLink: true,
      },
      {
        title: (
          <>
            <Icon svg="tiktok" width={20} height={20} /> TikTok
          </>
        ),
        to: "https://vt.tiktok.com/ZSVgToCVx/",
        isLink: true,
      },
      {
        title: (
          <>
            <Icon svg="youtube" width={20} height={20} /> Youtube
          </>
        ),
        to: "https://www.youtube.com/@MyCardGlobal",
        isLink: true,
      },
    ],
  },

  {
    tile: <>LEGAL</>,
    links: [
      {
        title: "Terms of service",
        to: "/terms",
        isLink: true,
      },
      {
        title: "Privacy Policy",
        to: "/privacy-policy",
        isLink: true,
      },
      {
        title: "Careers",
        to: "/careers",
        isLink: true,
      },
    ],
  },
];

export const Footer = () => {
  return (
    <>
      <div className="w-full border-y border-grey-200">
        <div
          className={`max-width py-[56px] lg:py-[80px] flex flex-col lg:flex-row gap-8 justify-between`}
        >
          <div className="flex flex-col gap-8">
            <img src="/logo.svg" alt="logo" className="max-w-[152px]" />

            <div className="flex items-center gap-4 flex-wrap max-w-fit">
              <Button
                className="max-w-fit"
                text={"Get on Android"}
                icon="playstore-colored"
                variation="dark-grey"
                onClick={() => {
                  window.location.href = PLAYSTORE_URL;
                }}
              />

              <Button
                className="max-w-fit"
                text={"Get on Apple"}
                icon="apple"
                variation="dark-grey"
                onClick={() => {
                  window.location.href = APPSTORE_URL;
                }}
              />
            </div>

            <p className="text-sm text-grey-600">
              CONTACT US
              <br />
              <span className="text-base text-deep-primary font-medium">
                support@mycardglobal.com
              </span>
            </p>
          </div>

          <div
            className="
            flex flex-row flex-wrap gap-8
            "
          >
            {sections.map((section, idx) => {
              return (
                <div
                  className="flex flex-col gap-6 min-w-[148px] lg:min-w-[186px]"
                  key={`${idx}`}
                >
                  <p className="text-grey-600 font-medium text-sm">
                    {section.tile}
                  </p>

                  <div className="flex flex-col gap-4">
                    {section.links.map((link, sIdx) => {
                      const key = `${idx}-${sIdx}`;
                      const className = link.isHeader
                        ? "flex items-center gap-1 text-sm font-bold text-grey-700 mt-2"
                        : "flex items-center gap-1 text-base font-medium text-deep-primary";

                      return link.isLink ? (
                        <Link
                          key={key}
                          className={className}
                          to={link.to}
                          // target={"_blank"}
                          // rel="noreferrer"
                        >
                          {link.title}
                        </Link>
                      ) : (
                        <p key={key} className={className}>
                          {link.title}
                        </p>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Loan Disclosure */}
      <div className="w-full bg-grey-50 border-b border-grey-200">
        <div className="max-width py-6">
          <p className="text-xs text-grey-600 leading-relaxed">
            <span className="font-semibold text-grey-700">
              LOAN DISCLOSURE:
            </span>{" "}
            MyCardGlobal loans are subject to eligibility criteria and approval.
            Interest rates start from {QUICK_LOAN_INTEREST_RATE}% per month
            depending on loan product, amount, and term. All loans use a
            declining balance interest calculation method. Loan amounts range
            from ₦10,000 to ₦5,000,000. Repayment terms range from 1 to 24
            months. Late payment fees may apply. Early repayment is allowed and
            may reduce total interest paid. Your Debt Service Ratio (DSR) will
            be calculated to ensure affordable repayments. For full terms and
            conditions, visit our{" "}
            <a href="/terms" className="text-primary underline">
              Terms of Service
            </a>
            .
          </p>
        </div>
      </div>
      <div className="w-full text-center bg-grey-100 py-6 text-grey-900 text-base">
        © 2026 MyCardGlobal. All rights reserved
      </div>
    </>
  );
};
